import React, { Component } from 'react';
interface StoryboardProps {
  onClose: () => void;
}
function PhoneMockup({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="w-[200px] h-[380px] bg-[#01332b] rounded-[1.8rem] border-[6px] border-gray-300 overflow-hidden relative flex-shrink-0 shadow-lg" data-id="element-271">
      <div className="absolute top-0 inset-x-0 h-5 bg-[#01332b] z-10 flex justify-center" data-id="element-272">
        <div className="w-14 h-3 bg-gray-300 rounded-b-lg" data-id="element-273" />
      </div>
      <div className="mt-5 h-[calc(100%-20px)] flex flex-col p-4 overflow-hidden" data-id="element-274">
        {children}
      </div>
    </div>;
}
function Slide1Mockup() {
  return <PhoneMockup data-id="element-275">
      <div className="flex-1 flex flex-col items-center justify-center" data-id="element-276">
        <div className="text-[8px] text-[#05dd4d] uppercase tracking-widest mb-3" data-id="element-277">
          Solventum
        </div>
        <div className="w-12 h-12 rounded-full border-2 border-[#05dd4d]/40 flex items-center justify-center mb-4" data-id="element-278">
          <span className="text-xl font-extrabold text-[#05dd4d]" data-id="element-279">18</span>
        </div>
        <div className="w-full space-y-1 mb-5" data-id="element-280">
          <div className="w-full h-2 bg-white/20 rounded" data-id="element-281" />
          <div className="w-4/5 h-2 bg-white/20 rounded mx-auto" data-id="element-282" />
          <div className="w-3/5 h-2 bg-white/20 rounded mx-auto" data-id="element-283" />
        </div>
        <div className="grid grid-cols-2 gap-2 w-full" data-id="element-284">
          <div className="h-10 bg-white/10 rounded-lg border border-white/20 flex items-center justify-center text-base" data-id="element-285">
            🇬🇧
          </div>
          <div className="h-10 bg-white/10 rounded-lg border border-white/20 flex items-center justify-center text-base" data-id="element-286">
            🇳🇴
          </div>
          <div className="h-10 bg-white/10 rounded-lg border border-white/20 flex items-center justify-center text-base" data-id="element-287">
            🇸🇪
          </div>
          <div className="h-10 bg-white/10 rounded-lg border border-white/20 flex items-center justify-center text-base" data-id="element-288">
            🇩🇰
          </div>
        </div>
      </div>
    </PhoneMockup>;
}
function Slide2Mockup() {
  return <PhoneMockup data-id="element-289">
      <div className="flex justify-end mb-2" data-id="element-290">
        <div className="w-6 h-6 rounded-full border border-[#05dd4d] flex items-center justify-center" data-id="element-291">
          <span className="text-[7px] font-bold text-[#05dd4d]" data-id="element-292">18</span>
        </div>
      </div>
      <div className="space-y-1 mb-4" data-id="element-293">
        <div className="w-full h-2 bg-white/20 rounded" data-id="element-294" />
        <div className="w-3/4 h-2 bg-white/20 rounded" data-id="element-295" />
      </div>
      <div className="space-y-2 mb-4" data-id="element-296">
        <div className="h-8 bg-white/10 rounded-lg border border-white/20 flex items-center px-2" data-id="element-297">
          <div className="w-3/4 h-1.5 bg-white/30 rounded" data-id="element-298" />
        </div>
        <div className="h-8 bg-[#05dd4d] rounded-lg flex items-center px-2" data-id="element-299">
          <div className="w-1/2 h-1.5 bg-[#01332b] rounded" data-id="element-300" />
        </div>
        <div className="h-8 bg-white/10 rounded-lg border border-white/20 flex items-center px-2" data-id="element-301">
          <div className="w-2/3 h-1.5 bg-white/30 rounded" data-id="element-302" />
        </div>
      </div>
      <div className="mt-auto" data-id="element-303">
        <div className="h-8 bg-[#05dd4d] rounded-lg w-full" data-id="element-304" />
      </div>
    </PhoneMockup>;
}
function Slide3Mockup() {
  return <PhoneMockup data-id="element-305">
      <div className="flex justify-end mb-2" data-id="element-306">
        <div className="w-6 h-6 rounded-full border border-[#05dd4d] flex items-center justify-center" data-id="element-307">
          <span className="text-[7px] font-bold text-[#05dd4d]" data-id="element-308">15</span>
        </div>
      </div>
      <div className="w-full h-2 bg-white/20 rounded mb-3" data-id="element-309" />
      <div className="bg-white/10 rounded-lg p-2 mb-3 flex items-center gap-2" data-id="element-310">
        <span className="text-sm font-extrabold text-[#05dd4d]" data-id="element-311">42%</span>
        <div className="flex-1" data-id="element-312">
          <div className="w-[42%] h-1.5 bg-[#05dd4d] rounded-full mb-1" data-id="element-313" />
          <div className="w-3/4 h-1 bg-white/20 rounded" data-id="element-314" />
        </div>
      </div>
      <div className="space-y-1 mb-2" data-id="element-315">
        <div className="w-full h-1.5 bg-white/20 rounded" data-id="element-316" />
        <div className="w-4/5 h-1.5 bg-white/20 rounded" data-id="element-317" />
      </div>
      <div className="w-full h-16 bg-[#a1d4fd]/20 rounded-lg mb-3 flex items-center justify-center" data-id="element-318">
        <svg className="w-5 h-5 text-white/30" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-319">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-320" />
        </svg>
      </div>
      <div className="mt-auto space-y-1.5" data-id="element-321">
        <div className="h-7 bg-[#05dd4d] rounded-lg w-full" data-id="element-322" />
        <div className="h-7 bg-white/10 border border-white/20 rounded-lg w-full" data-id="element-323" />
      </div>
    </PhoneMockup>;
}
function Slide4Mockup() {
  return <PhoneMockup data-id="element-324">
      <div className="flex justify-end mb-2" data-id="element-325">
        <div className="w-6 h-6 rounded-full border border-[#05dd4d] flex items-center justify-center" data-id="element-326">
          <span className="text-[7px] font-bold text-[#05dd4d]" data-id="element-327">10</span>
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center" data-id="element-328">
        <div className="text-[8px] text-[#a1d4fd] uppercase tracking-widest mb-1" data-id="element-329">
          From
        </div>
        <div className="flex items-baseline gap-1 mb-4" data-id="element-330">
          <span className="text-2xl font-extrabold text-white/40 line-through" data-id="element-331">
            20
          </span>
          <span className="text-sm text-[#05dd4d]" data-id="element-332">→</span>
          <span className="text-2xl font-extrabold text-[#05dd4d]" data-id="element-333">2</span>
        </div>
        <div className="w-full bg-white/10 rounded-lg p-2 mb-3 flex gap-2" data-id="element-334">
          <div className="w-8 h-8 rounded-full bg-gray-500 border border-[#05dd4d] flex-shrink-0" data-id="element-335" />
          <div className="flex-1 space-y-1.5" data-id="element-336">
            <div className="w-full h-1.5 bg-white/30 rounded" data-id="element-337" />
            <div className="w-4/5 h-1.5 bg-white/30 rounded" data-id="element-338" />
            <div className="w-1/3 h-1.5 bg-[#05dd4d] rounded mt-1" data-id="element-339" />
          </div>
        </div>
        <div className="space-y-1 w-full mb-auto" data-id="element-340">
          <div className="w-3/4 h-1.5 bg-white/20 rounded mx-auto" data-id="element-341" />
          <div className="w-1/2 h-1.5 bg-white/20 rounded mx-auto" data-id="element-342" />
        </div>
        <div className="h-7 bg-[#05dd4d] rounded-lg w-full mt-3" data-id="element-343" />
      </div>
    </PhoneMockup>;
}
function Slide5Mockup() {
  return <PhoneMockup data-id="element-344">
      <div className="flex flex-col items-center mb-3" data-id="element-345">
        <div className="w-8 h-8 rounded-full border-2 border-[#05dd4d] flex items-center justify-center mb-1" data-id="element-346">
          <span className="text-[8px] font-bold text-[#05dd4d]" data-id="element-347">14s</span>
        </div>
        <div className="text-[7px] text-[#05dd4d] font-bold" data-id="element-348">
          ✓ Promise kept
        </div>
      </div>
      <div className="space-y-1 mb-4" data-id="element-349">
        <div className="w-full h-2 bg-white/20 rounded" data-id="element-350" />
        <div className="w-2/3 h-2 bg-white/20 rounded mx-auto" data-id="element-351" />
      </div>
      <div className="space-y-2 flex-1" data-id="element-352">
        <div className="w-full h-16 bg-white/10 border border-[#a1d4fd]/40 rounded-xl flex items-center px-2 gap-2" data-id="element-353">
          <div className="w-6 h-6 rounded bg-[#05dd4d]/20 flex-shrink-0" data-id="element-354" />
          <div className="flex-1 space-y-1" data-id="element-355">
            <div className="w-full h-1.5 bg-white/40 rounded" data-id="element-356" />
            <div className="w-2/3 h-1 bg-white/20 rounded" data-id="element-357" />
          </div>
        </div>
        <div className="w-full h-16 bg-white/10 border border-[#a1d4fd]/40 rounded-xl flex items-center px-2 gap-2" data-id="element-358">
          <div className="w-6 h-6 rounded bg-[#05dd4d]/20 flex-shrink-0" data-id="element-359" />
          <div className="flex-1 space-y-1" data-id="element-360">
            <div className="w-full h-1.5 bg-white/40 rounded" data-id="element-361" />
            <div className="w-2/3 h-1 bg-white/20 rounded" data-id="element-362" />
          </div>
        </div>
      </div>
    </PhoneMockup>;
}
function Slide6Mockup() {
  return <PhoneMockup data-id="element-363">
      <div className="w-2/3 h-2 bg-white/20 rounded mx-auto mb-4" data-id="element-364" />
      <div className="space-y-2 mb-3" data-id="element-365">
        <div className="flex gap-1.5" data-id="element-366">
          <div className="h-6 bg-white/10 rounded flex-1" data-id="element-367" />
          <div className="h-6 bg-white/10 rounded flex-1" data-id="element-368" />
        </div>
        <div className="h-6 bg-white/10 rounded w-full" data-id="element-369" />
        <div className="h-6 bg-white/10 rounded w-full" data-id="element-370" />
        <div className="flex gap-1.5" data-id="element-371">
          <div className="h-6 bg-white/10 rounded flex-1" data-id="element-372" />
          <div className="h-6 bg-white/10 rounded flex-1" data-id="element-373" />
        </div>
      </div>
      <div className="flex gap-1.5 items-start mb-auto" data-id="element-374">
        <div className="w-3 h-3 rounded border border-white/30 flex-shrink-0 mt-0.5" data-id="element-375" />
        <div className="space-y-1 flex-1" data-id="element-376">
          <div className="w-full h-1 bg-white/20 rounded" data-id="element-377" />
          <div className="w-4/5 h-1 bg-white/20 rounded" data-id="element-378" />
        </div>
      </div>
      <div className="h-7 bg-white/15 rounded-lg w-full mt-3" data-id="element-379" />
    </PhoneMockup>;
}
const MOCKUPS = [Slide1Mockup, Slide2Mockup, Slide3Mockup, Slide4Mockup, Slide5Mockup, Slide6Mockup];
interface SlideData {
  number: number;
  name: string;
  experience: string;
  intent: string;
  psychology: string;
}
const SLIDES: SlideData[] = [{
  number: 1,
  name: 'Language Selection + Hook',
  experience: 'The user lands on a clean, branded opening screen. A pulsing "18" visual draws the eye, paired with the headline: "Invest the next 18 seconds to see how you can save 18 minutes on all future bonding appointments!" They choose their language (EN, NO, SV, DA) and a countdown timer starts.',
  intent: 'Set the stakes. Make them curious. Start the clock.',
  psychology: '"This will only take 18 seconds — I\'m in."'
}, {
  number: 2,
  name: 'The Poll (Self-Identification)',
  experience: 'A simple, relatable question: "How would you use 18 minutes saved at every bonding?" Three tappable options: Spend more time på fjellet 🏔️, Add one more patient, Stay on schedule. A green CTA is already visible for fast-movers. Tapping an option highlights it and auto-advances.',
  intent: 'Get them to self-identify their motivation. This answer personalizes everything that follows.',
  psychology: '"That sounds nice — I\'d love that."'
}, {
  number: 3,
  name: 'Peer Results + Reality Check',
  experience: 'Based on their choice, they see visualized poll results (e.g. 42% chose fjellet), a personalized hero image (mountain scene, dental clinic, or clock), and tailored copy. The green CTA remains consistent. A "Next →" button continues the story.',
  intent: 'Validate their desire. Show the gap between what they want and what bonding currently costs in time.',
  psychology: '"Wait, I don\'t have that today."'
}, {
  number: 4,
  name: 'The Proof (Dr. Selliseth)',
  experience: 'A dramatic number animation: 20 → 2. The "20" fades away and "2" scales up in green. A testimonial card features Dr. Nils Jørgen Selliseth\'s photo and quote: "Tidligere kunne bonding ta rundt 20 minutter… nå tar det bare et par minutter." The green CTA drives to conversion.',
  intent: 'Real doctor. Real quote. Real result. This is the moment belief clicks.',
  psychology: '"Oh… this is actually possible."'
}, {
  number: 5,
  name: 'CTA Options (Personalized)',
  experience: 'The timer stops. If ≤18s: "✓ Promise kept! That took just 14 seconds." The headline adapts to their poll answer (e.g. "How to get more time on the mountain"). Two clear options: Book a short web meeting, or Send me getting-started material.',
  intent: 'Low-friction conversion. Two paths, both valuable. No dead ends.',
  psychology: '"They kept their promise — I trust this."'
}, {
  number: 6,
  name: 'Intake Form',
  experience: 'A clean form collects: name, role, clinic, address, email, phone. A consent checkbox ensures GDPR compliance. Submit button matches their choice: "Request my meeting" or "Send me the material." On submit: warm thank-you confirmation.',
  intent: 'Capture the lead while motivation is highest.',
  psychology: '"Quick and easy — done."'
}];
export function Storyboard({
  onClose
}: StoryboardProps) {
  return <div className="bg-white min-h-screen" data-id="element-380">
      <style data-id="element-381">{`
        @media print {
          .no-print { display: none !important; }
          .slide-row { page-break-inside: avoid; }
          @page { margin: 1.2cm; size: A4; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>

      {/* Sticky nav */}
      <div className="no-print sticky top-0 z-50 bg-white border-b border-gray-200 px-6 py-3 flex justify-between items-center" data-id="element-382">
        <div className="flex items-center gap-2" data-id="element-383">
          <div className="w-7 h-7 rounded-full bg-[#01332b] flex items-center justify-center" data-id="element-384">
            <span className="text-[#05dd4d] font-bold text-xs" data-id="element-385">S</span>
          </div>
          <span className="font-bold text-gray-800 text-sm" data-id="element-386">Storyboard</span>
        </div>
        <div className="flex gap-3" data-id="element-387">
          <button onClick={() => window.print()} className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold px-3 py-1.5 rounded-lg transition-colors" data-id="element-388">
            🖨️ Print / Save PDF
          </button>
          <button onClick={onClose} className="text-xs bg-[#01332b] hover:bg-[#024a3e] text-white font-bold px-3 py-1.5 rounded-lg transition-colors" data-id="element-389">
            ← Back to Prototype
          </button>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-10" data-id="element-390">
        {/* Cover */}
        <div className="mb-12 pb-8 border-b-4 border-[#05dd4d]" data-id="element-391">
          <p className="text-[#01332b] text-xs font-bold uppercase tracking-[0.2em] mb-3" data-id="element-392">
            Solventum Dental
          </p>
          <h1 className="text-3xl font-extrabold text-gray-900 mb-2" data-id="element-393">
            SNAK Storyflow
          </h1>
          <h2 className="text-lg text-gray-500 mb-6" data-id="element-394">
            Interactive Sales Narrative Activation Kit — Digital Bonding
          </h2>
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 mb-6" data-id="element-395">
            <p className="text-gray-700 leading-relaxed text-sm" data-id="element-396">
              We hook dental professionals with a simple, personal question —
              then guide them through an 18-second journey from curiosity to
              conversion. Every interaction is personalized based on their first
              answer. A persistent countdown timer gamifies the experience.
            </p>
          </div>
          <div className="flex gap-4 text-center" data-id="element-397">
            <div className="flex-1 bg-[#01332b] rounded-xl p-3" data-id="element-398">
              <div className="text-xl font-extrabold text-[#05dd4d]" data-id="element-399">18s</div>
              <div className="text-[#a1d4fd] text-[10px]" data-id="element-400">Interaction time</div>
            </div>
            <div className="flex-1 bg-[#01332b] rounded-xl p-3" data-id="element-401">
              <div className="text-xl font-extrabold text-[#05dd4d]" data-id="element-402">18min</div>
              <div className="text-[#a1d4fd] text-[10px]" data-id="element-403">
                Saved per bonding
              </div>
            </div>
            <div className="flex-1 bg-[#01332b] rounded-xl p-3" data-id="element-404">
              <div className="text-xl font-extrabold text-[#05dd4d]" data-id="element-405">6</div>
              <div className="text-[#a1d4fd] text-[10px]" data-id="element-406">Screens</div>
            </div>
          </div>
        </div>

        {/* Introduction */}
        <div className="mb-12 pb-8 border-b border-gray-200" data-id="element-407">
          <h3 className="text-lg font-extrabold text-gray-900 mb-5" data-id="element-408">
            Introduction
          </h3>
          <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-409">
            <p data-id="element-410">
              <strong className="text-gray-900" data-id="element-411">
                The core idea is simple: we don't sell speed — we sell time.
              </strong>
            </p>
            <p data-id="element-412">
              Instead of focusing on inefficiencies in bonding, the narrative
              shifts to what becomes possible when time is no longer a
              constraint. This is anchored in a clear promise: a small
              investment of attention leads to a meaningful gain in time.
            </p>
            <p data-id="element-413">
              A live countdown reinforces this from the first second — not as
              pressure, but as proof. It signals that the experience delivers
              exactly what it promises: fast, focused, and worth the time. It
              creates a feeling of <em data-id="element-414">"promise made — promise kept."</em>
            </p>
            <p data-id="element-415">
              The experience then moves directly to reward through a simple
              poll: how would you use the time saved? Treat more patients, stay
              on schedule, or reclaim personal time. The poll is not just
              interaction — it is the first reward. It allows the user to define
              the value themselves, across ethos, logos, and pathos.
            </p>
            <p data-id="element-416">
              This makes the message immediately personal. Combined with a
              light, humorous tone, the focus stays on possibility rather than
              problem, lowering resistance and increasing engagement.
            </p>
            <div className="bg-[#01332b] rounded-xl p-5 my-6" data-id="element-417">
              <p className="text-white/90 text-sm leading-relaxed mb-3" data-id="element-418">
                Structured through the{' '}
                <strong className="text-[#05dd4d]" data-id="element-419">
                  Promise–Effort–Reward
                </strong>{' '}
                model: a strong promise captures attention, the countdown
                demonstrates that effort is minimal and respected, and the poll
                delivers a personalized reward.
              </p>
              <p className="text-white/90 text-sm leading-relaxed mb-3" data-id="element-420">
                From there, the realization follows naturally:{' '}
                <em className="text-[#a1d4fd]" data-id="element-421">"I don't have this today."</em>
              </p>
              <p className="text-white/90 text-sm leading-relaxed" data-id="element-422">
                At that point, the product becomes the obvious solution — not
                because it was pushed, but because the value has already been
                experienced.
              </p>
            </div>
          </div>
        </div>

        {/* Slide rows — mockup left, text right */}
        {SLIDES.map((slide, idx) => {
        const MockupComponent = MOCKUPS[idx];
        return <div key={slide.number} className="slide-row flex gap-8 mb-12 pb-10 border-b border-gray-200 last:border-b-0" data-id="element-423">
              {/* Phone mockup */}
              <div className="flex-shrink-0" data-id="element-424">
                <MockupComponent data-id="element-425" />
              </div>

              {/* Text */}
              <div className="flex-1 flex flex-col justify-center min-w-0" data-id="element-426">
                <div className="flex items-center gap-2 mb-4" data-id="element-427">
                  <div className="w-7 h-7 rounded-full bg-[#01332b] text-[#05dd4d] flex items-center justify-center text-xs font-extrabold flex-shrink-0" data-id="element-428">
                    {slide.number}
                  </div>
                  <h3 className="text-lg font-extrabold text-gray-900" data-id="element-429">
                    {slide.name}
                  </h3>
                </div>

                <div className="mb-4" data-id="element-430">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-431">
                    What happens
                  </p>
                  <p className="text-gray-700 text-sm leading-relaxed" data-id="element-432">
                    {slide.experience}
                  </p>
                </div>

                <div className="flex gap-3" data-id="element-433">
                  <div className="flex-1 rounded-lg p-3" style={{
                backgroundColor: '#f0fdf4',
                borderLeft: '3px solid #05dd4d'
              }} data-id="element-434">
                    <p className="text-[10px] font-bold text-[#01332b] uppercase tracking-wider mb-0.5" data-id="element-435">
                      Intent
                    </p>
                    <p className="text-gray-800 text-xs font-medium" data-id="element-436">
                      {slide.intent}
                    </p>
                  </div>
                  <div className="flex-1 bg-gray-50 rounded-lg p-3" style={{
                borderLeft: '3px solid #d1d5db'
              }} data-id="element-437">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5" data-id="element-438">
                      User thinks
                    </p>
                    <p className="text-gray-600 text-xs italic" data-id="element-439">
                      {slide.psychology}
                    </p>
                  </div>
                </div>
              </div>
            </div>;
      })}

        {/* Psychology Journey */}
        <div className="mb-10 pb-8 border-b border-gray-200" data-id="element-440">
          <h3 className="text-lg font-extrabold text-gray-900 mb-4" data-id="element-441">
            User Psychology Journey
          </h3>
          <div className="flex items-center gap-2 flex-wrap" data-id="element-442">
            <div className="bg-gray-100 rounded-lg px-3 py-2 text-center" data-id="element-443">
              <div className="text-[9px] text-gray-500" data-id="element-444">Screen 1–2</div>
              <div className="text-xs font-bold text-gray-800" data-id="element-445">
                "That sounds nice"
              </div>
            </div>
            <div className="text-gray-300" data-id="element-446">→</div>
            <div className="bg-gray-100 rounded-lg px-3 py-2 text-center" data-id="element-447">
              <div className="text-[9px] text-gray-500" data-id="element-448">Screen 3</div>
              <div className="text-xs font-bold text-gray-800" data-id="element-449">
                "I don't have that"
              </div>
            </div>
            <div className="text-gray-300" data-id="element-450">→</div>
            <div className="bg-gray-100 rounded-lg px-3 py-2 text-center" data-id="element-451">
              <div className="text-[9px] text-gray-500" data-id="element-452">Screen 4</div>
              <div className="text-xs font-bold text-gray-800" data-id="element-453">
                "This is possible"
              </div>
            </div>
            <div className="text-gray-300" data-id="element-454">→</div>
            <div className="bg-[#01332b] rounded-lg px-3 py-2 text-center" data-id="element-455">
              <div className="text-[9px] text-[#a1d4fd]" data-id="element-456">Screen 5–6</div>
              <div className="text-xs font-bold text-[#05dd4d]" data-id="element-457">👉 Convert</div>
            </div>
          </div>
        </div>

        {/* Design Principles */}
        <div className="mb-8" data-id="element-458">
          <h3 className="text-lg font-extrabold text-gray-900 mb-4" data-id="element-459">
            Design Principles
          </h3>
          <div className="grid grid-cols-2 gap-3" data-id="element-460">
            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200" data-id="element-461">
              <div className="text-xs font-bold text-gray-900 mb-0.5" data-id="element-462">
                🎨 Clinical & Nordic
              </div>
              <div className="text-[10px] text-gray-600" data-id="element-463">
                Dark green, neon green, soft blue. Clean, trustworthy.
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200" data-id="element-464">
              <div className="text-xs font-bold text-gray-900 mb-0.5" data-id="element-465">
                🎯 Personalized
              </div>
              <div className="text-[10px] text-gray-600" data-id="element-466">
                Every screen adapts to the user's first answer.
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200" data-id="element-467">
              <div className="text-xs font-bold text-gray-900 mb-0.5" data-id="element-468">
                ⚡ Fast
              </div>
              <div className="text-[10px] text-gray-600" data-id="element-469">
                18-second timer creates urgency without pressure.
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200" data-id="element-470">
              <div className="text-xs font-bold text-gray-900 mb-0.5" data-id="element-471">
                🚀 No dead ends
              </div>
              <div className="text-[10px] text-gray-600" data-id="element-472">
                Green CTA available from the first poll screen onward.
              </div>
            </div>
          </div>
        </div>

        <div className="text-center text-gray-400 text-[10px] py-6" data-id="element-473">
          Total interaction: ~18 seconds · Time saved: 18 minutes per
          appointment, every appointment, forever.
        </div>
      </div>
    </div>;
}